import {
  QueryKey,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { bankAccountService } from 'commons/services';
import { GetBankAccountDataType } from 'commons/services/bankAccountService/bankAccountService';

type UseBankAccountOptions = Omit<
  UseQueryOptions<GetBankAccountDataType>,
  'queryKey' | 'queryFn'
>;

export const useBankAccount = (
  options?: UseBankAccountOptions,
  returnDefaultBankAccount = false,
): UseQueryResult<GetBankAccountDataType> => {
  const queryKey: QueryKey = ['bankAccount', { returnDefaultBankAccount }];

  return useQuery({
    queryKey,
    queryFn: () => bankAccountService.getBankAccount(returnDefaultBankAccount),
    ...options,
  });
};
